import { MenuOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";
import mergeClassNames from "common/mergeClassNames";
import React from "react";

interface MenuPanelContainerProps {
    recordKeys: Record<string, string>;
    selectedKey?: string;
    className?: string;
    children?: React.ReactNode;
    onChange: (key: string) => void;
}

/**
 * Container with a dropdown menu. E.g. used in DataSets.js
 */
export default function MenuPanelContainer({
    recordKeys,
    selectedKey,
    className = "",
    children,
    onChange,
}: MenuPanelContainerProps) {
    const dataSetMenuItems: MenuProps["items"] = React.useMemo(() => {
        const items: MenuProps["items"] = [];
        for (const [key, value] of Object.entries(recordKeys)) {
            items.push({
                label: <span>{value}</span>,
                key: key,
                onClick: () => onChange(key),
            });
        }
        return items;
    }, [onChange, recordKeys]);

    return (
        <div
            className={mergeClassNames(
                "relative flex size-full flex-1 flex-col",
                className,
            )}
        >
            <Dropdown
                menu={{
                    items: dataSetMenuItems,
                }}
                trigger={["click"]}
            >
                <div
                    className="flex w-full cursor-pointer flex-row justify-between gap-2 pb-4 text-xl hover:text-blue-500"
                    aria-label="Click to select menu"
                >
                    <span className="font-bold">
                        {selectedKey ? recordKeys[selectedKey] : ""}
                    </span>
                    <MenuOutlined className="text-blue-600 hover:text-blue-300" />
                </div>
            </Dropdown>
            <div className="relative flex size-full flex-1 flex-col overflow-auto">
                {children}
            </div>
        </div>
    );
}
